import React from 'react';
import { Chip, Tooltip } from '@mui/material';

const sensitivityConfig = {
  'offen': {
    label: 'Offen',
    color: 'success',
    tooltip: 'Keine Einschränkungen'
  },
  'pseudonymisiert': {
    label: 'Pseudonymisiert',
    color: 'info',
    tooltip: 'Personenidentifizierende Daten wurden entfernt'
  },
  'anonymisiert': {
    label: 'Anonymisiert',
    color: 'default',
    tooltip: 'Vollständig anonymisiert'
  },
  'vertraulich': {
    label: 'Vertraulich',
    color: 'warning',
    tooltip: 'Zugriff nur mit besonderer Genehmigung'
  },
  'streng vertraulich': {
    label: 'Streng vertraulich',
    color: 'error',
    tooltip: 'Höchste Vertraulichkeitsstufe'
  }
};

const SensitivityBadge = ({ level, size = 'small', variant = 'outlined' }) => {
  const config = sensitivityConfig[level] || sensitivityConfig['pseudonymisiert'];

  return (
    <Tooltip title={config.tooltip}>
      <Chip
        label={config.label}
        color={config.color}
        size={size}
        variant={variant}
      />
    </Tooltip>
  );
};

export default SensitivityBadge;
